import type { useToast } from '@chakra-ui/react';

export type ContactSalesToastFn = ReturnType<typeof useToast>;

const CONTACT_SALES_TOAST_DURATION_MS = 6000;
const CONTACT_SALES_TOAST_POSITION = 'top-right' as const;

export function toastContactSalesRequestError(showToast: ContactSalesToastFn) {
  showToast({
    title: 'Something went wrong',
    description: 'We could not send your request. Please try again later.',
    status: 'error',
    duration: CONTACT_SALES_TOAST_DURATION_MS,
    isClosable: true,
    position: CONTACT_SALES_TOAST_POSITION,
  });
}

export function toastContactSalesRequestSuccess(
  showToast: ContactSalesToastFn
) {
  showToast({
    title: 'E-mail sent!',
    description:
      "We've sent an e-mail to both you and a member of our Sales Team to connect.",
    status: 'success',
    duration: CONTACT_SALES_TOAST_DURATION_MS,
    isClosable: true,
    position: CONTACT_SALES_TOAST_POSITION,
  });
}

export function toastContactSalesAlreadyNotified(
  showToast: ContactSalesToastFn
) {
  showToast({
    title: 'Thank you!',
    description:
      'We’ve notified a member of our Sales Team, who will reach out shortly.',
    status: 'success',
    duration: CONTACT_SALES_TOAST_DURATION_MS,
    isClosable: true,
    position: CONTACT_SALES_TOAST_POSITION,
  });
}
